import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card'
import { HeaderComponent } from '../core/layouts/header/header.component';
import { FooterComponent } from '../core/layouts/footer/footer.component';
import { LogInComponent } from '../core/auth/log-in/log-in.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getMkPaginatorIntl } from './mat-paginator-intl-mk';
import { FormsModule } from '@angular/forms';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { WebcamModule } from 'ngx-webcam';
import { RouterOutlet } from "@angular/router";
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from "@angular/material/menu";
import { ForgotPasswordComponent } from '../core/auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from '../core/auth/reset-password/reset-password.component';


@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    LogInComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent

  ],
  imports: [
    CommonModule,
    MatCardModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatSnackBarModule,
    TranslateModule.forRoot(),
    MatSidenavModule,
    MatListModule,
    MatSelectModule,
    MatTableModule,
    MatPaginatorModule,
    MatExpansionModule,
    MatDialogModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    FormsModule,
    LeafletModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatDatepickerModule,
    MatNativeDateModule,
    WebcamModule,
    MatTooltipModule,
    RouterOutlet,
    MatMenuModule,
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    LogInComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    MatCardModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatSnackBarModule,
    TranslateModule,
    MatSidenavModule,
    MatListModule,
    MatSelectModule,
    MatTableModule,
    MatPaginatorModule,
    MatExpansionModule,
    MatDialogModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    FormsModule,
    LeafletModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatDatepickerModule,
    MatNativeDateModule,
    WebcamModule,
    MatTooltipModule,
  ],
  providers: [
    {
      provide: MatPaginatorIntl,
      useFactory: getMkPaginatorIntl
    }
  ]
})
export class SharedModule { }
